import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'

export const StyledIconMute = styled('svg')({
    width: calcRem(20),
    height: calcRem(20),
})
